import { TableCell, TableRow, Tooltip } from '@mui/material';
import { styled } from '@mui/system';
import Graph from './SustainabilityGraphComponent';
import {useState} from "react";  // Adjust the import path as necessary

const StyledTableRow = styled(TableRow)({
  '&:hover': {
    backgroundColor: '#e6f7ff',
  },
  '&:last-child td, &:last-child th': {
    border: 0,
  },
});

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  borderBottom: '1px solid #dee2e6',
  padding: theme.spacing(1),
}));

function SustainabilityTableRow({ row, cloudProviderQuery }) {
  const [showGraph, setShowGraph] = useState(null);
  const [graphData, setGraphData] = useState(null);

  const handleGraphOpen = (type) => {
    setShowGraph(type);
  };

  const handleGraphClose = () => {
    setShowGraph(null);
  };

  return (
    <>
      <StyledTableRow key={row.name}>
        <StyledTableCell component="th" scope="row" align="center">
          {row.Continent_Name}
        </StyledTableCell>
        <StyledTableCell align="center">
          {row.Country_Name}
        </StyledTableCell>
        <StyledTableCell align="center">
          {cloudProviderQuery === "AWS" ? row.AWS_Region : cloudProviderQuery === "Azure" ? row.Azure_Region : row.GCP_Region}
        </StyledTableCell>
        <StyledTableCell align="right">
          <span
            style={{
              color: row.carbon_intensity <= 200 ? 'green' : 'brown',
              cursor: 'pointer',
              textDecoration: 'underline'
            }}
            onClick={() => handleGraphOpen('carbon_intensity')}
            onMouseOver={(e) => e.target.style.color = 'blue'}
            onMouseOut={(e) => e.target.style.color = row.carbon_intensity <= 200 ? 'green' : 'brown'}
          >
             <b> {row.carbon_intensity.toFixed(2) + " gCO2/kWh"} </b>
          </span>
        </StyledTableCell>
        <StyledTableCell align="right">
          <span
            style={{
              color: row.carbon_intensity <= 200 ? 'green' : 'brown',
              cursor: 'pointer',
              textDecoration: 'underline'
            }}
            onClick={() => handleGraphOpen('fossil_fuel_percentage')}
            onMouseOver={(e) => e.target.style.color = 'blue'}
            onMouseOut={(e) => e.target.style.color = row.carbon_intensity <= 200 ? 'green' : 'brown'}
          >
             <b> {row.fossil_fuel_percentage.toFixed(2) + "%"} </b>
          </span>
        </StyledTableCell>
      </StyledTableRow>

      <Graph type={showGraph} region={row.Zone_Name + "-" + row.Zone_Id} onClose={handleGraphClose} />
    </>
  );
}

export default SustainabilityTableRow;
